import { useMemo } from 'react'
import { trpc } from '@klear/ui/lib/trpc'
import { useMutationWithToast, createToastConfig } from '@klear/ui/hooks/use-mutations-with-toast'

export function useSupplierExternalBankAccounts(supplierId: number | undefined) {
  const {
    data: rawAccounts,
    error,
    isLoading
  } = trpc.supplierExternalBankAccount.list.useQuery(
    { supplierId: supplierId ?? 0 },
    {
      enabled: !!supplierId,
      refetchOnMount: true
    }
  )

  const supplierExternalBankAccounts = useMemo(() => rawAccounts ?? [], [rawAccounts])

  return { supplierExternalBankAccounts, error, isLoading }
}

const invalidateQueries = ['supplierExternalBankAccount.list', 'supplierExternalBankAccount.get']

export function useSupplierExternalBankAccountMutations() {
  const previewMutation = trpc.supplierExternalBankAccount.preview.useMutation()

  const commitMutation = useMutationWithToast(
    trpc.supplierExternalBankAccount.commit.useMutation,
    createToastConfig('Supplier Bank Account', 'update'),
    { invalidateQueries }
  )

  const deleteMutation = useMutationWithToast(
    trpc.supplierExternalBankAccount.delete.useMutation,
    createToastConfig('Supplier Bank Account', 'delete'),
    { invalidateQueries }
  )

  return {
    previewSupplierExternalBankAccount: previewMutation.mutateAsync,
    commitSupplierExternalBankAccount: commitMutation.mutateAsync,
    deleteSupplierExternalBankAccount: deleteMutation.mutateAsync,
    isPreviewing: previewMutation.isPending,
    isCommitting: commitMutation.isPending,
    isDeleting: deleteMutation.isPending
  }
}
